(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-contact-form"]) return;
  try {
    
(function () {
  if (window.__hpGuardBound) return;
  window.__hpGuardBound = true;
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || typeof f.matches !== 'function' || !f.matches('form[data-hp-field]')) return;
    var el = f.elements[f.getAttribute('data-hp-field')];
    if (el && el.value) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-estimate-form"]) return;
  try {
    
(function () {
  if (window.__hpGuardBound) return;
  window.__hpGuardBound = true;
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || typeof f.matches !== 'function' || !f.matches('form[data-hp-field]')) return;
    var el = f.elements[f.getAttribute('data-hp-field')];
    if (el && el.value) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rn-contact"]) return;
  try {
    
(function () {
  if (window.__hpGuardBound) return;
  window.__hpGuardBound = true;
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || typeof f.matches !== 'function' || !f.matches('form[data-hp-field]')) return;
    var el = f.elements[f.getAttribute('data-hp-field')];
    if (el && el.value) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rn-reservation-form"]) return;
  try {
    
(function () {
  if (window.__hpGuardBound) return;
  window.__hpGuardBound = true;
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || typeof f.matches !== 'function' || !f.matches('form[data-hp-field]')) return;
    var el = f.elements[f.getAttribute('data-hp-field')];
    if (el && el.value) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-quick"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__hpGuardBound) return;
  window.__hpGuardBound = true;
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || typeof f.matches !== 'function' || !f.matches('form[data-hp-field]')) return;
    var el = f.elements[f.getAttribute('data-hp-field')];
    if (el && el.value) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-page-shindan-form"]) return;
  try {
    
(function () {
  if (window.__hpGuardBound) return;
  window.__hpGuardBound = true;
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || typeof f.matches !== 'function' || !f.matches('form[data-hp-field]')) return;
    var el = f.elements[f.getAttribute('data-hp-field')];
    if (el && el.value) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-quick"]) return;
  try {
    
(function () {
  if (window.__hpGuardBound) return;
  window.__hpGuardBound = true;
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || typeof f.matches !== 'function' || !f.matches('form[data-hp-field]')) return;
    var el = f.elements[f.getAttribute('data-hp-field')];
    if (el && el.value) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
})();

  } catch(e) { console.error(e); }
})();
})();
